import { Routes, Route } from "react-router-dom";
import { InterventionsList } from "../Pages/Private/Task/InterventionsList";
import { InterventionsPlanning } from "../Pages/Private/Task/InterventionsPlanning";
import { InterventionsStats } from "../Pages/Private/Task/InterventionsStats";

export const InterventionRouter = () => {
    return (
        <Routes>
            <Route path="list" element={<InterventionsList />} />
            <Route path="planning" element={<InterventionsPlanning />} />
            <Route path="stats" element={<InterventionsStats />} />
        </Routes>
    );
};

export default InterventionRouter;
